import { Card, Skeleton, Stack } from '@mantine/core'
import { pickCurrentHour } from './weatherData'
import CurrentConditionsHero from './CurrentConditionsHero'

// Current-conditions card, built from the Claude Design handoff
// (docs/design_handoff_marine_forecast/). Sits between the map and 7-Day
// Insights on tide/current station pages — the daily/hourly forecast lives in
// each day's own WeekCard instead (DayWeatherBand, in the Weather section),
// paired with that day's tide/current data.
//
// Mirrors the old WeatherPanel's loading/absent contract: a fixed-height
// skeleton while loading (deterministic on SSR + first client render, so
// there's no hydration mismatch or layout shift once data resolves), nothing
// at all on 'absent'/'error' — weather is a bonus layer, its absence isn't an
// error worth showing the visitor.
export default function MarineForecastRail({ weather, timezone }) {
  const { status, data } = weather

  if (status === 'loading') {
    return (
      <Card withBorder padding={0} radius="md">
        <Stack gap={0} p={18}>
          <Skeleton height={18} width="40%" />
          <Skeleton height={110} mt={14} />
          <Skeleton height={70} mt={12} />
        </Stack>
      </Card>
    )
  }
  if (status !== 'ready' || !data) return null

  const picked = pickCurrentHour(data.hourly)
  if (!picked) return null

  return (
    // No border: the card is a solid TILE band now, like the weather section
    // inside each day card, and a border around a filled tile reads as a
    // second edge.
    <Card padding={0} radius="md" style={{ overflow: 'hidden' }}>
      <CurrentConditionsHero
        hour={picked.hour}
        timezone={timezone}
        forecasterText={data.forecaster_text}
      />
    </Card>
  )
}
